import { Button, type ButtonProps, cn } from '@seen/ui'
import type { ReactNode } from 'react'
import { IconDisplay } from '#src/components/icons/IconDisplay.tsx'

export interface DisplayButtonProps extends Omit<
  ButtonProps,
  'children' | 'variant' | 'size'
> {
  showIndicator?: boolean
}

export function DisplayButton({
  showIndicator = false,
  className,
  ...delegated
}: DisplayButtonProps): ReactNode {
  return (
    <Button
      variant="outline"
      size="icon"
      className={cn('size-7', className)}
      {...delegated}
    >
      <DisplayIconWithIndicator showIndicator={showIndicator} />
    </Button>
  )
}

function DisplayIconWithIndicator({
  showIndicator,
}: {
  showIndicator: boolean
}): ReactNode {
  return (
    <div className="relative size-4">
      <IconDisplay />
      {showIndicator && (
        <div className="absolute -top-0.75 -right-0.75 size-2.25 rounded-full border-2 border-white bg-blue-300" />
      )}
    </div>
  )
}
